import React from "react";
import "./styles.scss";

const getInitials = (name, maxLetters = 2) => {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (maxLetters <= 1 || parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

/**
 * Foto do usuário com fallback para as iniciais do nome. `photo` aceita tanto
 * a string de URL quanto o objeto `photo_url` ({original, small, thumbnail})
 * devolvido pela API.
 */
export const Avatar = ({ name, photo, size = 36, initialFontSize, maxInitials = 2 }) => {
    const src = typeof photo === 'string'
        ? photo
        : (photo?.thumbnail ?? photo?.small ?? photo?.original ?? null);
    const initials = getInitials(name, maxInitials);

    const style = { width: size, height: size, fontSize: initialFontSize ?? Math.round(size / 2.6) };

    return (
        <span className="avatar" style={style}>
            {src
                ? <img src={src} alt={name || 'Avatar'} />
                : <span className="avatar-initials">{initials}</span>
            }
        </span>
    );
};

export default Avatar;
